import { render, staticRenderFns } from "./ConfiguracoesInventarioFlorestal.vue?vue&type=template&id=e9bb696e"
import script from "./ConfiguracoesInventarioFlorestal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracoesInventarioFlorestal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports